import { useAppDisplayModeContext } from '@archipro-design/aria';
import { useFetcher } from '@remix-run/react';
import { useLatest } from 'ahooks';
import { useEffect } from 'react';
import type { action } from '~/routes/remix-api.home.toggle-home-pin';
import { TOGGLE_HOME_PIN } from '~/routes/remix-api.home.toggle-home-pin';
import { fetcherIsDone } from '~/utils/fetcherHelper';

type CallbackFn = (error: { __typename: string; Message: string }) => void;

export const useToggleHomePin = (canHomePin: boolean, onError?: CallbackFn) => {
    const { desktop: isDesktop } = useAppDisplayModeContext();
    const fetcher = useFetcher<typeof action>();
    const onErrorRef = useLatest<CallbackFn | undefined>(onError);

    const toggleHomePin = async (itemID: number, pin: boolean) => {
        if (!isDesktop || !canHomePin || itemID <= 0) {
            return;
        }

        fetcher.submit(
            {
                itemID: itemID,
                pin: pin,
            },
            {
                method: 'post',
                action: TOGGLE_HOME_PIN,
            }
        );
    };

    useEffect(() => {
        const hasError =
            fetcherIsDone(fetcher) &&
            fetcher.data?.HomePinToggle?.__typename === 'UserError';
        if (hasError) {
            onErrorRef.current?.(fetcher.data.HomePinToggle);
        }
    }, [fetcher, onErrorRef]);

    return {
        toggleHomePin,
    };
};
